import {
  IAdapterConfig,
  MiddlewareConfigClass
} from '@care-portals/api-interfaces';

const config = {
  precisionPharmacy: {
    label: 'Precision Pharmacy',
    functions: {
      upsertPatient: {
        version: 2,
        label: 'Upsert Patient',
        middlewareHandler: 'precision',
        params: [{ key: 'customerId', type: 'string', label: 'Customer ID' }]
      },
      getPatient: {
        version: 2,
        label: 'Get Patient',
        middlewareHandler: 'precision',
        params: [{ key: 'customerId', type: 'string', label: 'Customer ID' }]
      },
      upsertPrescription: {
        version: 2,
        label: 'Upsert Prescription',
        middlewareHandler: 'precision',
        passPayload: true,
        pipelines: ['order'],
        params: []
      },
      cancelPrescription: {
        version: 2,
        label: 'Cancel Prescription',
        middlewareHandler: 'precision',
        passPayload: true,
        pipelines: ['order'],
        params: []
      },
      upsertFill: {
        version: 2,
        label: 'Upsert Order',
        middlewareHandler: 'precision',
        passPayload: true,
        pipelines: ['order'],
        params: []
      },
      cancelFill: {
        version: 2,
        label: 'Cancel Order',
        middlewareHandler: 'precision',
        passPayload: true,
        pipelines: ['order'],
        params: []
      },
      getFill: {
        version: 2,
        label: 'Get Order',
        middlewareHandler: 'precision',
        passPayload: true,
        pipelines: ['order'],
        params: []
      },
      handleWebhook: {
        version: 2,
        label: 'Handle Webhook',
        middlewareHandler: 'precision',
        pipelines: ['webhook'],
        passPayload: true,
        params: []
      }
    }
  }
} as const;

export const PrecisionConfig: IAdapterConfig = {
  ...config
} as unknown as IAdapterConfig;

export type PrecisionFunctionConfiguration = MiddlewareConfigClass<
  typeof config.precisionPharmacy.functions
>;
